"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementalBlessingFrostEffectHandler = exports.ElementalBlessingFrostEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
/**
 * @deprecated
 */
class ElementalBlessingFrostEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.ElementalBlessingFrost;
        this.__typeName = "ElementalBlessingFrost";
        this.name = "Elemental Blessing of Frost";
        this.harmful = false;
    }
}
exports.ElementalBlessingFrostEffectArgs = ElementalBlessingFrostEffectArgs;
let ElementalBlessingFrostEffectHandler = class ElementalBlessingFrostEffectHandler {
    apply(sequence, container, state) { }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
ElementalBlessingFrostEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.ElementalBlessingFrost)
], ElementalBlessingFrostEffectHandler);
exports.ElementalBlessingFrostEffectHandler = ElementalBlessingFrostEffectHandler;
